<div class="flex flex-row align-items-center gap-3 p-2">
  <i class="ph-duotone ph-timer text-6xl"></i>
  @if (auth.timeExpiration() === 0) {
  <h2>Sesión expirada</h2>
  } @else {
  <h2>Sesión a punto de expirar</h2>
  }
</div>
@if (auth.timeExpiration() > 0) {
<p>{{ auth.timeExpirationMessage() }}</p>
<p>¿Desea extenderla o cerrar sesión?</p>
}
<div class="flex justify-content-end gap-2 pt-4 col-12">
  @if (auth.timeExpiration() === 0) {
  <button
    pButton
    label="Aceptar"
    (click)="ref.close()"
    class="p-button-secondary"></button>
  } @else {
  <button
    pButton
    label="Cerrar sesión"
    (click)="logout()"
    class="p-button-secondary"></button>
  <button
    pButton
    label="Extender sesión"
    (click)="extend()"
    class="p-button-primary"></button>
  }
</div>
